module.exports = __webpack_public_path__ + "ba30cff54511c48f42ceae2834595e81.png";